function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#95A1B2;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-247 -247)"
}, /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M251.837,261.038v.014a.545.545,0,0,0,0,.057l0,.036.005.034c0,.022.01.044.016.066v0a.731.731,0,0,0,.051.127l0,.007.021.036.017.028.008.011a.643.643,0,0,0,.082.1l0,0h0a.3.3,0,0,0,.026.024l.026.024a.729.729,0,0,0,.469.169h2.015a.737.737,0,0,0,0-1.474h-.236l1.876-1.875.007-.007,2.454-2.454v.236a.736.736,0,1,0,1.473,0v-2.01a.7.7,0,0,0,0-.08v-.005c0-.022-.006-.045-.01-.067l0-.013c0-.019-.009-.039-.015-.058l0-.01a.472.472,0,0,0-.022-.059v0a.708.708,0,0,0-.156-.232.723.723,0,0,0-.359-.2l-.015,0-.036-.005a.687.687,0,0,0-.112-.009h-2.015a.737.737,0,1,0,0,1.473h.237l-2.454,2.453-1.865,1.866,0-.231a.737.737,0,0,0-.73-.745h-.007a.739.739,0,0,0-.737.729l-.02,2.036v.006Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M262.844,247H249.156A2.261,2.261,0,0,0,247,249.349v13.3A2.261,2.261,0,0,0,249.156,265h13.688A2.261,2.261,0,0,0,265,262.651v-13.3A2.261,2.261,0,0,0,262.844,247Zm-14.491,4.3h15.3v11.355a.843.843,0,0,1-.8.875H249.156a.842.842,0,0,1-.8-.875Zm15.3-1.474h-15.3v-.473a.842.842,0,0,1,.8-.875h13.688a.843.843,0,0,1,.8.875Z"
}));

var SvgView = function SvgView(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgView, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/view.2fcd3683.svg";
export { ForwardRef as ReactComponent };